import About from './components/About';
import Contact from './components/Contact';
import Header from './components/Header';
import Hero from './components/Hero';
import MotionMarquee from './components/MotionMarquee';
import Portfolio from './components/Portfolio';
import Services from './components/Services';
import SemanticDOMBridge from './components/SemanticDOMBridge';
import SiteMotion from './components/SiteMotion';
import SiteFooter from './components/SiteFooter';
import SkipLink from './components/SkipLink';
import { CookieConsent } from './components/CookieConsent';
import { ThemeProvider, useTheme } from './contexts/ThemeContext';
import { LegalPage } from './pages/LegalPage';
import { resolveLegalPage } from './pages/legalRoutes';

const Site = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div
      id="top"
      className="min-h-screen overflow-hidden bg-canvas text-ink transition-colors duration-300"
    >
      <SkipLink />
      <SemanticDOMBridge />
      <SiteMotion />
      <Header theme={theme} onThemeChange={setTheme} />
      <main id="main-content">
        <Hero />
        <MotionMarquee />
        <Portfolio />
        <Services />
        <About />
        <Contact />
      </main>
      <SiteFooter currentPath="/" />
      <CookieConsent />
    </div>
  );
};

interface AppProps {
  pathname?: string;
}

function App({ pathname }: AppProps) {
  const currentPath = pathname ?? (typeof window === 'undefined' ? '/' : window.location.pathname);
  const legalPage = resolveLegalPage(currentPath);

  return <ThemeProvider>{legalPage ? <LegalPage kind={legalPage} /> : <Site />}</ThemeProvider>;
}

export default App;
